import { typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';
import { THEME_UI_DEFAULT_KEY } from './types.esm.js';

function hasDefault (x) {
  return _typeof(x) === 'object' && x !== null && THEME_UI_DEFAULT_KEY in x;
}

export default hasDefault;
//# sourceMappingURL=has-default.esm.js.map
